// Decides whether a pathname may be visited without being logged in.
// Used by the auth provider to choose between rendering and redirecting to /login.

// Generic public segments — a path is public when ANY segment matches one of these.
// 'open' keeps every share link of the form /:tenant/<route>/:id/open working.
const publicSegments = [
    'open',
    'createaccount',
    'Register',
    'RegisterInvitation',
    'NotApproved',
    'signup',
    'impactplan',
]

// Public route names — so a share link that lost its trailing /open segment
// (e.g. cut off in an email) still renders instead of bouncing to /login.
const publicRouteNames = [
    'livereportopen',
    'livereportopen2',
    'questionnaireopen',
    'eventopen',
    'intakeformopen',
    'storytellingopen',
    'impactopen',
]

const isPublicPath = (pathname) => {

    if (pathname === '/login') {
        return true
    }

    return pathname
        .split('/')
        .some(segment => publicSegments.includes(segment) || publicRouteNames.includes(segment))
}

export default isPublicPath
